import React from 'react';
import { sellerConstants } from '../../_constants/seller.constants';
import swal from 'sweetalert2';



const initialState = { removeSellerImageLoading: true, data: '', error: false, errorText: '', showSwal: true };

export function removeSellerImage(state = initialState, action) {
  switch (action.type) {
    case sellerConstants.REQUEST_REMOVE_SELLER_IMAGE:
      return {
        removeSellerImageLoading: true,
        data: '',
        error: false,
        errorText: ''
      };
    case sellerConstants.REMOVE_SELLER_IMAGE_SUCCESS:
      swal({
        text: 'Image Deleted successfully.',
        type: 'success',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'OK'
      })
      return {
        removeSellerImageLoading: false,
        data: action.data,
        error: false,
        errorText: ''
      };
    case sellerConstants.REMOVE_SELLER_IMAGE_ERROR:

      return {
        removeSellerImageLoading: false,
        data: '',
        error: true,
        errorText: action.error
      };
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/_reducers/sellers/removeSellerImage.reducer.js